<div class="dialog-title-header">
  <div class="title-container">
    <div class="title">
      <nmfta-icon name="warning_amber"></nmfta-icon>
      <h2>{{ 'SESSION_TIMEOUT.TITLE' | translate }}</h2>
    </div>
    <nmfta-button [color]="'error'"
                  styleType="text"
                  [blackText]="true"
                  iconName="close"
                  mat-dialog-close>
    </nmfta-button>
  </div>
</div>

<mat-dialog-content>
  <div class="p-4">
    <p class="short-description">{{ 'SESSION_TIMEOUT.DESCRIPTION' | translate }}.</p>
    <p class="mt-2">
      {{ 'SESSION_TIMEOUT.TIME_REMAINING' | translate }}: <strong>{{ timeFormatted }}</strong>
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <nmfta-button id="logout"
                styleType="outlined"
                color="error"
                rightIcon="logout"
                (buttonClick)="logout()">
    {{ 'SESSION_TIMEOUT.LOG_OUT_NOW' | translate }}
  </nmfta-button>
  <nmfta-button id="continue"
                styleType="contained"
                (buttonClick)="continue()">
    {{ 'SESSION_TIMEOUT.STAY_LOGGED_IN' | translate }}
  </nmfta-button>
</mat-dialog-actions>
